import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Infrastructure from './infrastructure'
import Vue3Tour from 'vue3-tour'
import { createDexie } from './dexie'
import { createWorkerSupervisor } from './worker-supervisor'
import Charts from './charts'

export function registerPlugins(app, router, appStoreFn, idbEntities) {
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  app.use(pinia)
  app.use(Infrastructure)
  createWorkerSupervisor(app, appStoreFn, idbEntities)
  app.use(Vue3Tour)
  app.use(createDexie(appStoreFn, idbEntities))
  app.use(router)
  app.use(Charts)
}
